import React from 'react'
import { useSelector } from 'react-redux'
import isAdmin from '../Utils/isAdmin'

const AdminPermission = ({children}) => {
    const user = useSelector(state => state.user)
  return (
    <>
        {
            isAdmin(user.role) ? children : <p>Do not have permission</p>
        }
    </>
  )
}

export default AdminPermission